export default "__VITE_ASSET__BOYAB9cB__"